import React from 'react';
import { renderInline } from '../markdown/Markdown';

// Renders questions with the same look as the existing FAQ sections
// (styles live in komprimatorer.css). Answers support **bold** and [links](/url).
// The prerender step turns every `.faq-item` on a page into FAQPage structured data.
const FaqList = ({ items }) => (
    <div className="komprimatorer-faq">
        {items.map((item, index) => (
            <details className="faq-item" key={index}>
                <summary>{item.question}</summary>
                {String(item.answer)
                    .split(/\n{2,}/)
                    .map((paragraph, i) => (
                        <p key={i}>{renderInline(paragraph, `faq-${index}-${i}`)}</p>
                    ))}
            </details>
        ))}
    </div>
);

export default FaqList;
